<section class="summary-panel">
  <header class="summary-panel__header">
    <h2 class="summary-panel__title">{{ title }}</h2>
    @if (subtitle) {
    <p class="summary-panel__subtitle">{{ subtitle }}</p>
    }
  </header>

  <div class="summary-panel__rows">
    @for (row of rows; track row.label + '-' + $index) {
    <div class="summary-panel__row" [class.summary-panel__row--stacked]="row.layout === 'stacked'">
      <span class="summary-panel__label">{{ row.label }}</span>
      <strong class="summary-panel__value">{{ row.value }}</strong>
    </div>
    }
  </div>
</section>
